export const NUMBER_OF_STORIES_PER_TOPIC = 5;
export const CAROUSEL_CARD_WIDTH = 300;
export const CAROUSEL_CARD_GAP = 12;
export const MAX_TOPICS = 12;
export const SHOW_TOPIC_PICKER_COOKIE = "show_topic_picker";

import { ItemGroup } from "./TagPicker/types";

const COPY_TEXT = "Choose up to 12 markets topics to track the latest news.";

enum ContentTagType {
  topic = "Topic",
  country = "Country",
  region = "Region",
  classification = "Classification",
  location = "Location",
}

const ALLOWED_TOPICS: {
  [x: string]: {
    name: string;
    tagType: string;
  };
} = {
  "private-credit": {
    name: "Private Credit",
    tagType: ContentTagType.topic,
  },
  "global-trade": {
    name: "Trade",
    tagType: ContentTagType.topic,
  },
  "investment-banking": {
    name: "Investment Banks",
    tagType: ContentTagType.topic,
  },
  mergers: {
    name: "Deals",
    tagType: ContentTagType.topic,
  },
  inflation: {
    name: "Inflation",
    tagType: ContentTagType.topic,
  },
  "artificial-intelligence": {
    name: "AI",
    tagType: ContentTagType.topic,
  },
  cryptocurrency: {
    name: "Crypto",
    tagType: ContentTagType.topic,
  },
  "monetary-policy": {
    name: "Monetary Policy",
    tagType: ContentTagType.topic,
  },
  currency: {
    name: "Currencies",
    tagType: ContentTagType.topic,
  },
  "hedge-funds": {
    name: "Hedge Funds",
    tagType: ContentTagType.topic,
  },
  "private-equity": {
    name: "Private Equity",
    tagType: ContentTagType.topic,
  },
  startups: {
    name: "Startups",
    tagType: ContentTagType.topic,
  },
  technology: {
    name: "Tech",
    tagType: ContentTagType.classification,
  },
  taxes: {
    name: "Taxes",
    tagType: ContentTagType.topic,
  },
  CA: {
    name: "Canada",
    tagType: ContentTagType.country,
  },
  "latin-america": {
    name: "Latin America",
    tagType: ContentTagType.location,
  },
  Asia: {
    name: "Asia",
    tagType: ContentTagType.region,
  },
  Europe: {
    name: "Europe",
    tagType: ContentTagType.region,
  },
  GB: {
    name: "UK",
    tagType: ContentTagType.country,
  },
  Middleeast: {
    name: "Middle East",
    tagType: ContentTagType.region,
  },
  Africa: {
    name: "Africa",
    tagType: ContentTagType.region,
  },
  IN: {
    name: "India",
    tagType: ContentTagType.country,
  },
  CN: {
    name: "China",
    tagType: ContentTagType.country,
  },
  "energy-industry": {
    name: "Energy",
    tagType: ContentTagType.topic,
  },
  "property-market": {
    name: "Property",
    tagType: ContentTagType.topic,
  },
  automotive: {
    name: "Automotive",
    tagType: ContentTagType.topic,
  },
  "aerospace-industry": {
    name: "Aerospace",
    tagType: ContentTagType.topic,
  },
  entertainment: {
    name: "Entertainment",
    tagType: ContentTagType.topic,
  },
  pharmaceutical: {
    name: "Pharmaceuticals",
    tagType: ContentTagType.topic,
  },
};

const RECOMMENDED_TOPICS = [
  {
    ...ALLOWED_TOPICS.cryptocurrency,
    id: "cryptocurrency",
  },
  {
    ...ALLOWED_TOPICS.entertainment,
    id: "entertainment",
  },
  {
    ...ALLOWED_TOPICS.retail,
    id: "retail",
  },
];

const TOPIC_GROUPS: ItemGroup[] = [
  {
    title: "Recommended",
    items: {
      "private-credit": {
        label: ALLOWED_TOPICS["private-credit"].name,
      },
      "hedge-funds": {
        label: ALLOWED_TOPICS["hedge-funds"].name,
      },
      mergers: {
        label: ALLOWED_TOPICS.mergers.name,
      },
      "investment-banking": {
        label: ALLOWED_TOPICS["investment-banking"].name,
      },
      "private-equity": {
        label: ALLOWED_TOPICS["private-equity"].name,
      },
      inflation: {
        label: ALLOWED_TOPICS.inflation.name,
      },
      "global-trade": {
        label: ALLOWED_TOPICS["global-trade"].name,
      },
      "artificial-intelligence": {
        label: ALLOWED_TOPICS["artificial-intelligence"].name,
      },
      cryptocurrency: {
        label: ALLOWED_TOPICS.cryptocurrency.name,
      },
      startups: {
        label: ALLOWED_TOPICS.startups.name,
      },
      taxes: {
        label: ALLOWED_TOPICS.taxes.name,
      },
      "monetary-policy": {
        label: ALLOWED_TOPICS["monetary-policy"].name,
      },
      currency: {
        label: ALLOWED_TOPICS.currency.name,
      },
    },
  },
  {
    title: "Regions",
    items: {
      CN: {
        label: ALLOWED_TOPICS.CN.name,
      },
      CA: {
        label: ALLOWED_TOPICS.CA.name,
      },
      "latin-america": {
        label: ALLOWED_TOPICS["latin-america"].name,
      },
      Europe: {
        label: ALLOWED_TOPICS.Europe.name,
      },
      GB: {
        label: ALLOWED_TOPICS.GB.name,
      },
      Asia: {
        label: ALLOWED_TOPICS.Asia.name,
      },
      Africa: {
        label: ALLOWED_TOPICS.Africa.name,
      },
      Middleeast: {
        label: ALLOWED_TOPICS.Middleeast.name,
      },
      IN: {
        label: ALLOWED_TOPICS.IN.name,
      },
    },
  },
  {
    title: "Sectors",
    items: {
      automotive: {
        label: ALLOWED_TOPICS.automotive.name,
      },
      "energy-industry": {
        label: ALLOWED_TOPICS["energy-industry"].name,
      },
      pharmaceutical: {
        label: ALLOWED_TOPICS.pharmaceutical.name,
      },
      "property-market": {
        label: ALLOWED_TOPICS["property-market"].name,
      },
      entertainment: {
        label: ALLOWED_TOPICS.entertainment.name,
      },
      "aerospace-industry": {
        label: ALLOWED_TOPICS["aerospace-industry"].name,
      },
    },
  },
];

export {
  COPY_TEXT,
  RECOMMENDED_TOPICS,
  ALLOWED_TOPICS,
  TOPIC_GROUPS,
  ContentTagType,
};
